import React, { ReactElement, ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export default function PanelArea(props: Props): ReactElement {
  const { children } = props;
  return (
    <div className="flex min-h-0 w-1/2 flex-col space-y-3 overflow-hidden">
      {children}
    </div>
  );
}
